import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addProduct } from "../../Redux/Product/action";
import { initialValues } from "./initialValues";

export default function ProductInputForm() {
  const dispatch = useDispatch();
  // LOCAL DECLARETION START
  const [values, setValues] = useState(initialValues);
  // LOCAL DECLARETION END
  // HANDLER FUNCTION START
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(addProduct(values));
    setValues(initialValues);
  };
  // HANDLER FUNCTION END
  return (
    <>
      <div>
        {/* <!-- Product Input Form --> */}
        <div className="formContainer">
          <h4 className="formTitle">Add New Product</h4>
          <form
            onSubmit={submitHandler}
            className="space-y-4 text-[#534F4F]"
            id="lws-addProductForm"
          >
            {/* <!-- product name --> */}
            <div className="space-y-2">
              <label htmlFor="lws-inputName">Product Name</label>
              <input
                className="addProductInput"
                id="lws-inputName"
                type="text"
                name="productName"
                value={values.productName}
                onChange={handleInputChange}
                required
              />
            </div>
            {/* <!-- product category --> */}
            <div className="space-y-2">
              <label htmlFor="lws-inputCategory">Category</label>
              <input
                className="addProductInput"
                id="lws-inputCategory"
                type="text"
                name="category"
                value={values.category}
                onChange={handleInputChange}
                required
              />
            </div>
            {/* <!-- product image url --> */}
            <div className="space-y-2">
              <label htmlFor="lws-inputImage">Image Url</label>
              <input
                className="addProductInput"
                id="lws-inputImage"
                type="text"
                name="imageUrl"
                value={values.imageUrl}
                onChange={handleInputChange}
                required
              />
            </div>
            {/* <!-- price & quantity container --> */}
            <div className="grid grid-cols-2 gap-8 pb-4">
              {/* <!-- price --> */}
              <div className="space-y-2">
                <label htmlFor="ws-inputPrice">Price</label>
                <input
                  className="addProductInput"
                  id="lws-inputPrice"
                  type="number"
                  name="price"
                  value={values.price}
                  onChange={handleInputChange}
                  required
                />
              </div>
              {/* <!-- quantity --> */}
              <div className="space-y-2">
                <label htmlFor="lws-inputQuantity">Quantity</label>
                <input
                  className="addProductInput"
                  id="lws-inputQuantity"
                  type="number"
                  name="quantity"
                  value={values.quantity}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
            {/* <!-- submit button --> */}
            <button type="submit" id="lws-inputSubmit" className="submit">
              Add Product
            </button>
          </form>
        </div>
        {/* <!-- Product Input Form Ends --> */}
      </div>
    </>
  );
}
